import React, { useEffect, useContext, useState, useRef } from 'react'
import parse from 'html-react-parser'

import { useGetTopOfElementById } from '../../hooks'
import withLocation from '../../common/with-location'

import { StateContext } from './state-context'

export const IntroduceRefer = withLocation(({ content, baseName, Location }) => {
  const { getTopOfElementById } = useGetTopOfElementById()
  const { dispatch } = useContext(StateContext)
  const [replaceContent, setReplaceContent] = useState(content)
  const ids = useRef([])

  useEffect(() => {
    const h2s = Array.from(content.matchAll(/(?<=<h2><span id=".+">).*(?=<\/span><\/h2>)/g))
    const h2Ids = Array.from(content.matchAll(/(?<=<h2><span id=").*(?=">.*<\/span><\/h2>)/g))

    let rc = content
    h2Ids.forEach(([id]) => {
      const reg = new RegExp(id)
      rc = rc.replace(reg, id + '___0')
      ids.current.push(id + '___0')
    })
    setReplaceContent(rc)

    h2s.forEach((arr, i) => {
      const p = {
        title: arr[0],
        id: h2Ids[i][0] + '___0',
        groupIndex: 0,
        children: [],
      }
      dispatch({ type: 'setMenu', payload: p })
    })
  }, [content, dispatch, setReplaceContent])

  useEffect(() => {
    if (window) {
      window.addEventListener('scroll', () => {
        ids.current.some(id => {
          const top = getTopOfElementById(id)
          if (top <= 0 && top > -100) {
            window.history.pushState(
              '',
              `${baseName}`,
              `${Location.origin}${Location.pathname}#${id}`,
            )
            dispatch({
              type: 'setHash',
              payload: id,
            })
            const groupIndex = id.split('___')[1]
            if (groupIndex !== undefined) {
              dispatch({
                type: 'setGroupIndex',
                payload: +groupIndex,
              })
            }
            window.localStorage.setItem('groupIndex', +groupIndex)
          }
          return top <= 0 && top > -100
        })
      })
    }
  }, [getTopOfElementById, dispatch, baseName, Location.origin, Location.pathname])

  return <>{parse(replaceContent.replaceAll('&', '&amp;'))}</>
})
